export const DOWNLOAD_CALIBRATION_CERTIFICATES_MODAL_ID = 'downloadCalibrationCertificatesModalId'

export const CALIBRATION_CERTIFICATE_FILE_TYPE = {
  PDF: 'pdf',
  XML: 'xml',
}
